import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaClock,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaWhatsapp,
} from 'react-icons/fa';
import logo from '../../images/newLogo-ÜçKardeşlerTS.jpg';
import SITE, { MAPS } from '../../Data/siteConfig';
import './footer.css';

const corporateLinks = [
  { to: '/hakkimizda', label: 'Hakkımızda' },
  { to: '/servislerimiz', label: 'Servislerimiz' },
  { to: '/iletisim', label: 'İletişim' },
  { to: '/konum', label: 'Konum' },
];

const serviceLinks = [
  { to: '/servislerimiz', label: 'Kombi Bakım & Tamir' },
  { to: '/servislerimiz', label: 'Petek Temizleme' },
  { to: '/servislerimiz', label: 'Beyaz Eşya Tamiri' },
  { to: '/servislerimiz/klima-bakimi', label: 'Klima Bakımı' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer-glow" aria-hidden />

      <div className="site-footer-inner">
        <div className="site-footer-grid">
          {/* Marka + CTA */}
          <div className="site-footer-brand">
            <Link to="/" className="site-footer-brand-link" aria-label={SITE.name}>
              <img src={logo} className="site-footer-logo" alt="" />
              <span className="site-footer-brand-text">
                <strong>{SITE.shortName}</strong>
                <small>Teknik Servis</small>
              </span>
            </Link>

            <p className="site-footer-tagline">
              Bursa Osmangazi merkezli kombi, klima ve beyaz eşya teknik servisi.
              7/24 güvenilir ve garantili hizmet.
            </p>

            <div className="site-footer-badges">
              <span className="site-footer-badge">7/24 Hizmet</span>
              <span className="site-footer-badge">Garantili İşçilik</span>
            </div>

            <div className="site-footer-cta">
              <a href={SITE.phoneHref} className="site-footer-cta-btn site-footer-cta-call">
                <FaPhoneAlt aria-hidden />
                Hemen Ara
              </a>
              <a
                href={SITE.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="site-footer-cta-btn site-footer-cta-wa"
              >
                <FaWhatsapp aria-hidden />
                WhatsApp
              </a>
            </div>
          </div>

          {/* Kurumsal */}
          <div className="site-footer-col">
            <h3 className="site-footer-heading">Kurumsal</h3>
            <ul className="site-footer-links">
              {corporateLinks.map(({ to, label }) => (
                <li key={to + label}>
                  <Link to={to} className="site-footer-link">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Hizmetler */}
          <div className="site-footer-col">
            <h3 className="site-footer-heading">Hizmetlerimiz</h3>
            <ul className="site-footer-links">
              {serviceLinks.map(({ to, label }) => (
                <li key={label}>
                  <Link to={to} className="site-footer-link">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* İletişim */}
          <div className="site-footer-col">
            <h3 className="site-footer-heading">İletişim</h3>
            <ul className="site-footer-contact">
              <li>
                <a href={SITE.phoneHref} className="site-footer-contact-item">
                  <span className="site-footer-contact-icon" aria-hidden>
                    <FaPhoneAlt />
                  </span>
                  <span>{SITE.phoneDisplay}</span>
                </a>
              </li>
              <li>
                <a href={SITE.emailHref} className="site-footer-contact-item">
                  <span className="site-footer-contact-icon" aria-hidden>
                    <FaEnvelope />
                  </span>
                  <span>{SITE.email}</span>
                </a>
              </li>
              <li>
                <a
                  href={MAPS.directionsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="site-footer-contact-item"
                >
                  <span className="site-footer-contact-icon" aria-hidden>
                    <FaMapMarkerAlt />
                  </span>
                  <span>{SITE.address.full}</span>
                </a>
              </li>
              <li>
                <span className="site-footer-contact-item site-footer-contact-static">
                  <span className="site-footer-contact-icon" aria-hidden>
                    <FaClock />
                  </span>
                  <span>{SITE.workingHours}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="site-footer-bottom">
          <p className="site-footer-copy">
            &copy; {year} {SITE.name}. Tüm hakları saklıdır.
          </p>

          <div className="site-footer-social">
            <a
              href={SITE.social.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="site-footer-social-link"
            >
              <FaFacebookF />
            </a>
            <a
              href={SITE.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="site-footer-social-link"
            >
              <FaInstagram />
            </a>
            <a
              href={SITE.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="site-footer-social-link site-footer-social-wa"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
